export default {
  en: {
    contactPerson: 'Contact Person',
    editContactPerson: 'Edit Contact Person',
    firstName: 'First Name',
    lastName: 'Last Name',
    position: 'Position',
    phone: 'Phone',
    mobile: 'Mobile',
    fax: 'Fax',
    email: 'Email',
    addEmail: 'Add Email',
    addMobile: 'Add Mobile',
    save: 'Save Changes',
    cancel: 'Cancel',
    editContactPersonSuccessTitle: 'Success',
    editContactPersonSuccessMessage: 'Update Contact Person Success.'
  },
  th: {
    contactPerson: 'ผู้ติดต่อ',
    editContactPerson: 'แก้ไขข้อมูลผู้ติดต่อ',
    firstName: 'ชื่อ',
    lastName: 'นามสกุล',
    position: 'ตำแหน่ง',
    phone: 'โทรศัพท์',
    mobile: 'มือถือ',
    fax: 'แฟกซ์',
    email: 'อีเมล',
    addEmail: 'เพิ่มอีเมล',
    addMobile: 'เพิ่มมือถือ',
    save: 'บันทึก',
    cancel: 'ยกเลิก',
    editContactPersonSuccessTitle: 'สำเร็จ',
    editContactPersonSuccessMessage: 'แก้ไขข้อมูลผู้ติดต่อสำเร็จ'
  }
}
